import styled from 'styled-components';

import HorizontalFlow from '../HorizontalFlow';
import VerticalFlow from '../VerticalFlow';

const Separator = styled.div`
  ${HorizontalFlow} > & {
    border-radius: 2px;
    background: var(--neutral-300);
    width: 4px;
    height: 4px;
  }
  ${VerticalFlow} > & {
    border-radius: 2px;
    background: var(--neutral-300);
    width: 100%;
    height: 2px;
  }
`;

export default Separator;
